import { RootState } from '@shared/model';

export const selectSenderState = (state: RootState) => state.emailSenderState;
export const selectSenderStateId = (state: RootState) => state.emailSenderState.stateId;
export const selectSenderErrors = (state: RootState) => state.emailSenderState.progress.emailSendingErrors;
export const selectIsSendingEmails = (state: RootState) => state.emailSenderState.isSending;
export const selectIsShowEmailErrors = (state: RootState) => state.emailSenderState.isShowEmailErrors;
export const selectEmailSendingProgress = (state: RootState) => state.emailSenderState.progress;
